import styled from 'styled-components';
import { Box, Text } from '@rsos/base-components';

export const InputTextLabel = styled(Text).attrs({
  size: 'normal',
  color: 'primaryText',
  mb: '7px',
})``;

export const BEErrorWrapper = styled(Box).attrs({
  py: 12,
  px: 20,
  bg: 'lightDanger',
  horizontal: true,
  color: 'background',
  flow: 12,
  borderRadius: 5,
  align: 'center',
})``;
